import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-blue-dark text-white" data-id="element-75" data-mp="3gfitoga0y7d2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center" data-id="element-76" data-mp="3gh3qydnq44em">
        <h2 className="text-xl font-black" data-id="element-77" data-mp="32p5qer82vgu2">🧾 EstudioPack RG 5866™</h2>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-white/70" data-id="element-78" data-mp="36oo8lf8ildt7">
          Pack operativo para contadores públicos que necesitan encuadrar los
          sujetos obligados de su cartera ante la Resolución General 5866/2026
          de ARCA antes de los primeros vencimientos.
        </p>
        <p className="mt-3 text-[15px] font-semibold text-white/90" data-id="element-79" data-mp="3ldanjfu8c3jw">
          Desarrollado por contadores para contadores. Sin cursos. Sin teoría.
          Sin vueltas.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/80" data-id="element-80" data-mp="29ynk7hc24zcf">
          <span className="inline-flex items-center gap-1.5" data-id="element-81" data-mp="2ezbau1wdje64">
            <MailIcon className="h-4 w-4" data-id="element-82" data-mp="3l9k7bh9idvfe" /> [email de soporte]
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-83" data-mp="3lbmuzun6vcgy">
            <InstagramIcon className="h-4 w-4" data-id="element-84" data-mp="3gbr0cm0dsxe2" /> [Instagram / LinkedIn]
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-85" data-mp="3v8rhxwouzbyt">
            <GlobeIcon className="h-4 w-4" data-id="element-86" data-mp="3q8n125k1gf82" /> [sitio web]
          </span>
        </div>

        <div className="mt-8 border-t border-white/15 pt-6 text-xs leading-relaxed text-white/50" data-id="element-87" data-mp="3qazrz87rxzx9">
          <p data-id="element-88" data-mp="80nrsermsiar">
            © EstudioPack RG 5866™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
            Material de uso profesional. No constituye asesoramiento jurídico ni
            impositivo.
          </p>
          <p className="mt-4 text-sm font-medium italic text-white/70" data-id="element-89" data-mp="cvtp09qhhje5">
            🗓️ "Aseguradoras: 1° de Septiembre. No esperes a agosto para
            notificar a tu cartera."
          </p>
        </div>
      </div>
    </footer>;
}